import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ProfileState } from './profile.reducer';


// Create a feature selector for the 'products' feature
export const selectProjectsState = createFeatureSelector<ProfileState>('profile');





export const selectCurrentUserProfile = createSelector(
  selectProjectsState,
  (state) => state.currentUserProfile
);

export const selectCurrentUserProfileProcess = createSelector(selectProjectsState, (state) => state.currentUserProfileProcess );

